export interface ChangelogEntry {
  version: string
  date: string
  changes: Array<{ type: 'feature' | 'improvement' | 'fix'; description: string }>
}

export const changelogEntries: ChangelogEntry[] = [
  {
    version: 'v1.27.0',
    date: 'April 2026',
    changes: [
      { type: 'feature', description: 'Equanaut Prime AI assistant — cross-organization context and conversational oversight (beta)' },
      { type: 'feature', description: 'Mattermost team messaging integration at /organization/[id]/messaging' },
      { type: 'improvement', description: 'Command Center messaging bridge now shows live connection status' },
      { type: 'fix', description: 'Corrected WebResponse types in messaging hooks; removed invalid BuiltInRole import' },
    ],
  },
  {
    version: 'v1.26.0',
    date: 'March 2026',
    changes: [
      { type: 'feature', description: 'Command Center: Comet Browser Dashboard with capability maturity radar and MCP tool inventory' },
      { type: 'feature', description: 'Agent Management page with active session tracking, orchestration tree, and queue viewer' },
      { type: 'improvement', description: 'Priority Stack now supports Top 3 / Top 7 / Top 15 / All views with urgency and impact scoring' },
      { type: 'fix', description: 'window.history renamed to window.__equaHistory to avoid native API conflict' },
    ],
  },
  {
    version: 'v1.25.0',
    date: 'February 2026',
    changes: [
      { type: 'feature', description: 'Equa Docs: full searchable platform documentation index with 100+ articles' },
      { type: 'feature', description: 'Organization agreements module with e-sign workflow' },
      { type: 'improvement', description: 'Google Auth smoke test coverage added to CI pipeline' },
      { type: 'improvement', description: 'Marketing site: Features, Security, Changelog, Privacy, Terms pages added' },
    ],
  },
  {
    version: 'v1.24.0',
    date: 'January 2026',
    changes: [
      { type: 'feature', description: 'ESOP / Stock Option Plan management with vesting schedule visualization' },
      { type: 'feature', description: 'Convertible instruments tracker: SAFEs, notes, and conversion events' },
      { type: 'improvement', description: 'Cap table exports now include fully diluted share counts' },
      { type: 'fix', description: 'Fixed date handling in vesting cliff calculations for leap years' },
    ],
  },
  {
    version: 'v1.23.0',
    date: 'December 2025',
    changes: [
      { type: 'feature', description: 'Google Drive integration: sync and link documents from your Drive to the data room' },
      { type: 'feature', description: 'Microsoft integration: connect Azure AD and OneDrive for document management' },
      { type: 'improvement', description: 'Document data room now supports folder hierarchy and drag-and-drop upload' },
      { type: 'fix', description: 'Resolved race condition in token refresh that caused intermittent 401 errors' },
    ],
  },
]
